import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {ModalService} from '../../../services/modal/modal.service';

@Component({
    selector: 'app-button-modal-close',
    templateUrl: './button-modal-close.component.html',
    styleUrls: ['./button-modal-close.component.scss'],
})
export class ButtonModalCloseComponent implements OnInit {
    @Input() public modalSize = 'lg';
    @Input() public modal: NgbModalRef;
    @Input() public tabIndex = -1;

    @Output() public closeEmit: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        protected modalService: ModalService,
    ) {
    }

    ngOnInit(): void {
        const subs = this.modalService.emitOnClose.subscribe(() => {
            this.closeEmit.emit();
            subs.unsubscribe();
        });
    }

    closeModal(): void {
        this.closeEmit.emit();
        this.modal.close(false);
    }

}
